export default __webpack_public_path__ + "static/media/discover.d28ccfbe.svg";